<template>
  <component-preview :heading="lang.get('judging.preview.heading')" class="mbx">
    <vip-juding-preview v-show="mode === 'vip_judging'" />
    <top-pick-preview v-show="mode === 'top_pick'" />
    <voting-preview v-show="mode === 'voting'" />
    <qualifying-preview v-show="mode === 'qualifying'" />
  </component-preview>
</template>

<script>
import ComponentPreview from '@/lib/components/ComponentPreview';
import VipJudingPreview from './VipJudgingPreview';
import TopPickPreview from './TopPickPreview';
import VotingPreview from './VotingPreview';
import QualifyingPreview from './QualifyingPreview';

export default {
  inject: ['lang'],
  components: {
    ComponentPreview,
    VipJudingPreview,
    TopPickPreview,
    VotingPreview,
    QualifyingPreview
  },
  props: {
    mode: {
      type: String,
      default: null
    }
  }
};
</script>
